import { cn } from '@/utils';
import { useAssignManager } from '../api/assignManager';
import { ManagerEvent } from '../types';
import { ManagerDropdown } from './ManagerDropdown';
import { TEvent } from '@/features/event/types';
import { useToast } from '@/components/ui/use-toast';
import { label } from '@/utils/label';
import { LabelGroup } from '@/features/label/types';

interface AssignManagerProps {
  event?: ManagerEvent | TEvent;
  className?: string;
}

export function AssignManager({ event, className }: AssignManagerProps) {
  const assignManagerMutation = useAssignManager({});
  const { toast } = useToast();

  const handleAssignManager = async (managerId?: number) => {
    if (!event) return;

    try {
      await assignManagerMutation.mutateAsync({
        data: {
          eventId: event.eventId,
          managerId
        }
      });
    } catch (error) {
      console.error('Error assigning manager:', error);
      toast({ variant: 'destructive', title: label('manager_assign_failed', LabelGroup.MANAGER_EVENT_HANDLING) });
    }
  };

  if (!event) return null;

  return (
    <div className={cn(className)}>
      <ManagerDropdown onChange={manager => handleAssignManager(manager.managerId)} value={event.assignedUserId || 0} />
    </div>
  );
}
